import type { ContractStatus, ContractType } from './types';

export const getContractStatusBadgeColor = (status: ContractStatus): string => {
  switch (status) {
    case 'ACTIVE':
      return 'bg-green-600';
    case 'NEW':
      return 'bg-blue-400';
    case 'CLOSED':
      return 'bg-purple-400';
    case 'TERMINATED':
      return 'bg-red-400';
    default:
      return 'bg-gray-300';
  }
};

export const getContractTypeBadgeColor = (type: ContractType): string => {
  switch (type) {
    case 'HOURLY':
      return 'bg-yellow-400';
    case 'SUCCESS_FEE':
      return 'bg-blue-300';
    case 'FIXED':
      return 'bg-green-600';
    case 'PRO_BONO':
      return 'bg-gray-400';
    default:
      return 'bg-gray-300';
  }
};
